<template>
  <div class="download">
    <div class="banners">
      <div class="banner-title">
        <div class="t1">政企数据价值化</div>
        <div class="t2">数据资产入表服务</div>
      </div>
      <video
        src="../assets/img/banner1.mp4"
        autoplay
        loop
        muted
        style="width: 100%; height: 100%; object-fit: cover; position: absolute; top: 0; left: 0;"
      />
    </div>
    <div class="content-1">
      <div class="content-1-1">
        <div class="title-top">
          <img src="../assets/img/left.png" alt="" />
          <div class="title1">应用场景</div>
          <img src="../assets/img/right.png" alt="" />
        </div>
        <div class="content-1-2">
          <div class="home-app-left">
            <div class="t1">数据资源及资产摸排盘点</div>
            <div class="t1">合规与确权</div>
            <div class="t1">数据治理</div>
            <div class="t1">数据资产运营</div>
            <div class="t1">数据流通交易</div>
          </div>
          <div class="home-app-center">国企、央企、上市公司</div>
          <div class="home-app-left">
            <div class="t1">数据要素建设</div>
            <div class="t1">数据安全审查</div>
            <div class="t1">数据评估</div>
            <div class="t1">数据资源会计入表</div>
            <div class="t1">数据资源入表服务生态联盟</div>
          </div>
        </div>
      </div>
    </div>



    <div class="content-1">
      <div class="content-1-1">
        <div class="title-top">
          <img src="../assets/img/left.png" alt="" />
          <div class="title1">应用案例</div>
          <img src="../assets/img/right.png" alt="" />
        </div>

        <div class="case-section">
          
          <div class="case-text" >
            中启联信科技集团有限公司牵头组建了数据资产价值链服务团队，在对某公交集团开展多次调研后，
            对其数据资源进行收集，经过了清洗加工、合规确权、质量评价、成本归集和分摊及资产登记等环节，
            最终完成数据资产评估及入表工作。在评估时，评估对象界定、收益能力分析、评估方法选择应用、
            重要评估参数确定、核查验证落实等方面，存在不同程度的困难，最终分别为某公交集团及其下属企业登记了多类数据资产，
            并通过数据交易平台进行后续的交易及管理。
          </div>
          
          <div class="case-img-group">
            <img src="../assets/img/zq/zz1.png" alt="案例展示图片1" class="case-img" >
            <img src="../assets/img/zq/zz2.png" alt="案例展示图片2" class="case-img" >
          </div>
        </div>
    </div>


    <div class="content-1">
      <div class="content-1-1">
        <div class="title-top">
          <img src="../assets/img/left.png" alt="" />
          <div class="title1">数据资产入表基本流程</div>
          <img src="../assets/img/right.png" alt="" />
        </div>
        <img style="margin:40px 0;width: 100%;" src="../assets/img/zq/lct.png" alt="" />
        <div class="jb-lists">
          <div class="list-item" v-for="(item, index) in sjList" :key="index">
            <div
              class="items"
              :class="
                hoverIndex == index
                  ? 'activeHover bg' + (index + 1)
                  : 'bg' + (index + 1)
              "
              @mouseenter="hoverIndex = index"
            >
              <div class="t11">{{ item.title }}</div>
              <div
                v-if="hoverIndex == index"
                style="white-space: pre-line;"
                class="t12"
              >
                {{ item.content }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
// import Banner from "../components/Banner";
export default {
  metaInfo: {
    title: "中启联信_数据资产入表",
    meta: [
      { name: "keywords", content: "中启联信、数据资产、数据资产入表" },
      { name: "description", content: "中启联信、数据资产、数据资产入表" },
    ],
  },
  data() {
    return {
      hoverIndex: 0,
      tabPosition: "left",
      activeName: "first",
      sjList: [
        {
          title: "数据治理",
          content:
            "确定数据标准;\n数据清洗;\n数据管理能力评估;\n数据资源目录梳理;\n……",
        },
        {
          title: "数据确权",
          content:
            "了解数据登记情况;\n界定数据来源、持有加工、流通、使用过程中的合法权利;\n明确权利或权利组合;\n获取相关权证材料;\n……",
        },
        {
          title: "数据入表专业咨询",
          content:
            "数据资产确认条件;\n基于场景的预期收益合理性判断;\n资产分类的合理性和确定依据分析;\n后续计量的价值影响分析;\n……",
        },
        {
          title: "数据资产质量评价",
          content:
            "明确数据质量评价对象及范围;\n建立质量要素评价指标体系;\n执行数据质量评价程序;\n撰写数据质量评价报告;\n……",
        },
        {
          title: "数据资产价值评估",
          content:
            "明确评估对象和范围明确应用场景和资产类型;\n数据资产评估方法适用性分析;\n数据资产价值评估;\n出具价值评估报告;\n……",
        },
      ],
      itemList: [
        {
          bg: require(`@/assets/img/advantage-0.png`),
          title: "上千次项目打磨",
        },
        {
          bg: require(`@/assets/img/advantage-1.png`),
          title: "100%项目交付质量",
        },
        {
          bg: require(`@/assets/img/advantage-2.png`),
          title: "量身打造定制化方案",
        },
        { bg: require(`@/assets/img/advantage-3.png`), title: "50+技术软著" },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.download {
  width: 100%;
  outline: none;
  .content-3 {
    margin-top: 80px;
    .content-3-1 {
      text-align: center;
    }
    .content-3-2 {
      width: 1400px;
      margin: 68px auto;
      display: flex;
      justify-content: space-between;
      .box1 {
        width: 288px;
        height: 274px;
        background: #3a4354;
        border-radius: 6px;
        background-size: 100% 100%;
        position: relative;
        overflow: hidden;
        .box1-1 {
          display: block;
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 45px;
          text-align: center;
          font-size: 16px;
          font-weight: 700;
          color: #fff;
          line-height: 24px;
        }
        .box1-2 {
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.6);
          overflow: hidden;
          color: #fff;
          text-align: center;
          opacity: 0;
          -webkit-animation: advantageHide 1s;
          animation: advantageHide 1s;
          @keyframes advantageHide {
            0% {
              opacity: 0;
            }
            100% {
              opacity: 1;
            }
          }
        }
      }
    }
  }
  .content-2 {
    background: #f9fbff;
    width: 100%;
    padding-top: 60px;
    min-width: 1200px;
    .content-2-3 {
      // width: 1200px;
      margin: 20px auto;
      ::v-deep .el-tabs__nav-scroll {
        width: 10%;
        margin: 0 auto;
      }
      .content-2-3-1 {
        width: 100%;
        min-width: 1200px;
        height: 23.43vw;
        background: #2b3953;
        position: relative;
        margin-top: 4.9vw;
        .text1 {
          text-align: left;
          color: #fff;
          width: 62.5vw;
          margin: 0 auto;
          padding-top: 5.28vw;
        }
        .img1 {
          opacity: 1;
          width: 50vw;
          height: 26.84vw;
          position: absolute;
          right: 0;
          bottom: 0;
          transition: all 0.5s ease-in 0.5s;
          animation: fadeIn 1s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
          @keyframes fadeIn {
            0% {
              opacity: 0;
            }
            100% {
              opacity: 1;
            }
          }
        }
        .img2 {
          width: 30.15vw;
          height: 15.98vw;
          position: absolute;
          right: 30.57vw;
          bottom: 0;
          animation: slide-in-bottom 1.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)
            forwards;
          @keyframes slide-in-bottom {
            0% {
              opacity: 0.5;
            }
            100% {
              opacity: 1;
            }
          }
        }
      }
    }
    .content-2-1 {
      text-align: center;
    }
    .content-2-2 {
      margin: 32px auto;
      text-align: center;
      .tabs {
        margin: 0 auto;

        ::v-deep .el-radio-button__inner {
          width: 400px;
          height: 48px;
          line-height: 24px;
          font-size: 20px;
        }
      }
    }
  }
  .content-1 {
    background: #fff;
    width: 100%;
    min-width: 1400px;
    .content-1-1 {
      text-align: center;
      .title-top {
        display: flex;
        justify-content: center;
        align-items: center;
        .title1 {
          font-size: 36px;
          margin: 0px 20px;
        }
      }
      // &:active {
      //   background: linear-gradient(135deg, #526aff, #7caefb) !important;
      //   color: #fff;
      // }
      .case-section {
        width: 100%;
        max-width: 1260px;
        margin: 40px auto;
        display: flex;
        align-items: center;
        gap: 40px;
        padding: 30px;
        background-color: #ffffff;
        border-radius: 12px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);

        .case-text {
          flex: 1;
          max-width: 420px;
          font-size: 24px;
          line-height: 1.8;
          color: #34495e;
          text-align: justify;
          padding-right: 10px;
          text-indent: 2em;
          }

        .case-img-group {
          flex: 0 0 auto;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          gap: 45px;
          margin-left: 45px;

          .case-img {
            width: 320px;
            border-radius: 8px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
            transition: transform 0.3s ease;
            object-fit: cover;

            &:hover {
              transform: translateY(-5px);
            }
          }
        }


      }
    }
  }



  .content-1 {
    width: 1400px;
    min-width: 1400px;
    margin: 130px auto;
    .content-1-1 {
      text-align: center;
      .jb-lists {
        display: flex;
        margin: 30px auto;
        width: 1400px;
        .list-item {
          height: 200px;
          .bg1 {
            background: linear-gradient(
              0deg,
              rgba(124, 174, 251, 0.2) 0%,
              rgb(82, 106, 255) 100%
            );
          }
          .bg2 {
            background: linear-gradient(
              0deg,
              rgba(120, 82, 255, 0.2) 0%,
              rgb(120, 82, 255) 100%
            );
          }
          .bg3 {
            background: linear-gradient(
              0deg,
              rgba(64, 237, 172, 0.2) 29%,
              rgb(64, 237, 172) 100%
            );
          }
          .bg4 {
            background: linear-gradient(
              180deg,
              rgba(82, 184, 255, 0.6) 29%,
              rgb(255, 255, 255) 100%
            );
          }
          .bg5 {
            background: linear-gradient(
              0deg,
              rgba(252, 255, 82, 0.2) 0%,
              rgb(235, 146, 13) 100%
            );
          }
          .items {
            width: 164px;
            height: 100%;
            padding: 28px 18px 41px 8px;
            border-radius: 10px;
            .t11 {
              color: #fff;
              font-size: 36px;
            }
            .t12 {
              margin-top: 40px;
              color: #fff;
              font-size: 18px;
              line-height: 40px;
            }
          }
          height: 434px;
          margin-right: 20px;
          background-position-x: -350px;
          background-repeat: no-repeat;
          transition: width 0.5s;
          border-radius: 10px;
          overflow: hidden;
        }
        .activeHover {
          background-position-x: 0px;
          width: 600px !important;
          box-shadow: rgba(0, 0, 0, 0.2) 0px 0px;
        }
      }
    }
    .content-1-2 {
      display: flex;
      margin-top: 30px;
      .home-app-left {
        width: 250px;
        height: 467px;
        background: linear-gradient(296deg, #7caefb, #526aff);
        box-shadow: 4px 6px 30px 0 rgba(0, 0, 0, 0.06);
        border-radius: 6px 0 0 6px;
        .t1 {
          font-size: 20px;
          color: #fff;
          line-height: 60px;
          margin: 20px 0;
        }
      }
      .home-app-center {
        width: 900px;
        height: 247px;
        background-image: url(https://databaker-gw-static.oss-accelerate.aliyuncs.com/assets/images/newHome/app-bg.png);
        background-size: 100% 100%;
        box-shadow: 4px 6px 30px 0 rgba(0, 0, 0, 0.06);
        border-radius: 0 6px 6px 0;
        position: relative;
        text-align: center;
        font-size: 40px;
        padding-top: 220px;
      }
      .home-app-right {
        width: 250px;
        height: 467px;
        background: linear-gradient(296deg, #7caefb, #526aff);
        box-shadow: 4px 6px 30px 0 rgba(0, 0, 0, 0.06);
        border-radius: 6px 0 0 6px;
      }
    }
  }
  .home-achieve {
    position: relative;
    width: 1400px;
    margin: -60px auto;
    display: flex;
    z-index: 3;
    justify-content: space-between;
    .cards {
      transform: translateY(0px);
      opacity: 1;
      animation-delay: 200ms;
      width: 388px;
      height: 112px;
      background: #fff;
      box-shadow: 2px 6px 10px 0 rgba(0, 0, 0, 0.12);
      border-radius: 12px;
      display: flex;
    }
  }
  .banners {
    width: 100%;
    height: 400px;
    position: relative;
    .banner-title {
      position: absolute;
      z-index: 3;
      width: 1400px;
      min-width: 1400px;
      top: 45%;
      left: 50%;
      transform: translate(-50%, -50%);
      .t1 {
        font-size: 2.2vw;
        font-family: Alibaba-PuHuiTi-Bold;
        color: #3a4354;
        font-weight: bold;
      }
      .t2 {
        font-size: 1.2vw;
        width: 567px;
        font-weight: 400;
        color: #3a4354;
        line-height: 40px;
        margin-top: 23px;
        font-family: Alibaba-PuHuiTi-Regular;
      }
    }
    video {
      height: 100%;
      width: 100%;
      position: absolute;
      right: 0px;
      top: 0px;
      // bottom: 0px;
      z-index: -1;
    }
  }
}








</style>
